<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">

                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <div>
                                    <img class="app-icon" src="/img/apps/ping/app_icon.png" alt="Ping App Icon">
                                    <h1 class="display-3 text-white">
                                        Ping – Network Monitor
                                        <span class="text-white">Easily monitor network services on the go.</span>
                                    </h1>
                                </div>
                                <p class="lead text-white">
                                    Ping is a slim yet powerful network analysis tool that allows you to ping devices on the network and troubleshoot connection issues.
                                </p>
                                <div class="btn-wrapper">
                                    <a href="https://frhlch.at/f/ping?app=1" target="_blank">
                                        <img width="150" src="/img/app/download_appstore.png" alt="Download Ping on the App Store">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <app-showcase 
                                    imageSrc="/img/apps/ping/ping_screen.jpeg" 
                                    videoSrc="https://www.dropbox.com/s/vu822saa2te6eri/ping_showcase.mp4?dl=1" 
                                    posterSrc="/img/apps/ping/ping_video_placeholder.png"
                                    class="floating"
                                    >
                                </app-showcase>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="feature-section section section-lg pt-lg-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        
                        <div class="row row-grid">
                            <div class="col-lg-12">
                                <h3>Features</h3>
                            </div>
                        </div>
                        <div class="row row-grid">
                            <div class="col-md-6 col-lg-4">
                                <div class="card card-gray shadow border-0 card-lift--hover">
                                    <img v-lazy="'img/apps/ping/feature_01.PNG'" class="card-img-top">
                                    <blockquote class="card-blockquote">
                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                            class="svg-bg">
                                            <polygon points="0,52 583,95 0,95" opacity="1" class="fill-dark"></polygon>
                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-dark"></polygon>
                                        </svg>
                                        <h4 class="display-6 font-weight-bold">Measure Connection Speed</h4>
                                        <p class="font-weight-400 text-italic">
                                            Open <strong>Ping</strong> and get and idea how fast your mobile connection is.
                                            Simply enter an IP address or an hostname and press Go.
                                        </p>
                                    </blockquote>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="card card-gray shadow border-0 card-lift--hover">
                                    <img v-lazy="'img/apps/ping/feature_02.PNG'" class="card-img-top" style="object-position: 0 -50px;">
                                    <blockquote class="card-blockquote">
                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                            class="svg-bg">
                                            <polygon points="0,52 583,95 0,95" opacity="1" class="fill-dark"></polygon>
                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-dark"></polygon>
                                        </svg>
                                        <h4 class="display-6 font-weight-bold">Monitor Server Uptime</h4>
                                        <p class="font-weight-400 text-italic">
                                            Check whether your servers are up and running while you are out of office.
                                            Quick-access your favorite servers using the history view.
                                        </p>
                                    </blockquote>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="card card-gray shadow border-0 card-lift--hover">
                                    <img v-lazy="'img/apps/ping/feature_03.PNG'" class="card-img-top" style="object-position: 0 -35px;">
                                    <blockquote class="card-blockquote">
                                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                            class="svg-bg">
                                            <polygon points="0,52 583,95 0,95" opacity="1" class="fill-dark"></polygon>
                                            <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-dark"></polygon>
                                        </svg>
                                        <h4 class="display-6 font-weight-bold">Configure Ping Packages</h4>
                                        <p class="font-weight-400 text-italic">
                                            Configure the parameters of the packages with which you are pinging.

                                        </p>
                                    </blockquote>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
   
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-1 mb-a">
                        <div class="pr-md-5">
                            <div>
                                <h3>9 Colorful Themes</h3>
                                <p>
                                    <strong>Ping</strong> comes with 9 different colorful themes. You are not a fan of Dark Mode? 
                                    Then choose one of the light themes. Black and White is too boring for you? Ping has you covered.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-2">
                        <div class="rounded carousel overflow-hidden transform-perspective-right">
                            <b-carousel id="carousel1"
                                        controls
                                        indicators>
                                <!-- Text slides with image -->
                                <b-carousel-slide img-src="img/apps/ping/theme_1_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_2_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_3_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_4_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_5_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_6_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_7_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_8_framed.png"></b-carousel-slide>
                                <b-carousel-slide img-src="img/apps/ping/theme_9_framed.png"></b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import BCarousel from "bootstrap-vue/es/components/carousel/carousel";
import BCarouselSlide from "bootstrap-vue/es/components/carousel/carousel-slide";

export default {
  name: "ping",
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>

<style scoped lang="css">

    .no-pointer-events {
        pointer-events: none;
    }

    h1 {
        display: inline-grid;
    }

    h1 span {
        font-size: 1.5rem;
        color: rgba(0,0,0,0.7);
    }

    .app-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        display: inline-grid;
        margin-right: 15px;
        margin-top: 10px;
    }

    .app-showcase {
        width: 350px;
        height: 700px;
        margin: auto;
        margin-top: 60px;
    }

    @media (min-width: 992px) {
        .app-showcase {
            position: absolute;
            top: -65px;
            right: 0;
        }
    }

    .section-shaped .shape-style-1.shape-default {
        /* background: linear-gradient(150deg, #ffffff 15%, #e0e0e0 70%, #afafaf 94%); */
        background: #f4f5f7;
        background: #222;
        background: linear-gradient(150deg, #222 15%, #111 70%, #000 94%);
    }

    .feature-section {
        margin-top: 200px;
    }

    .feature-section .display-block {
        display: block;
    }

    .feature-section .card-gray {
        background-color: #f4f5f7;
        max-height: 550px;
        height: 550px;
    }

    .feature-section .card-gray polygon {
        fill: #f4f5f7;
    }

    .feature-section .card-img-top {
        overflow: hidden;
        max-height: 250px;
        object-fit: cover;
        object-position: 0 -125px;
    }

    .mb-a {
        margin-bottom: auto;
    }

    .carousel {
        height: 600px;
        width: 300px;
        margin: auto;
    }   

    @media (min-width: 992px) {
        .carousel {
            float: right;
        }
    }

</style>
